import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Tracks each route change. Skips admin pages.
export default function VisitTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    const referrer = document.referrer || '';
    // Fire-and-forget; never block UI
    axios.post(`${API}/track-visit`, {
      path: location.pathname,
      referrer
    }).catch(() => { /* silent — analytics must never break UX */ });
  }, [location.pathname]);

  return null;
}
